<template>
    <div class="gd-modal">
      <div class="gd-modal__bckg" @click="closeModal()"></div>
      <div class="gd-modal__body">
        <div class="gd-modal__title">
          {{ title }}
          <button
            class="gd-rounded-btn gd-rounded-btn--small gd-modal__close"
            @click="closeModal()">
            <IconClose class="gd-rounded-btn__icon"></IconClose>
          </button>
        </div>
        <div class="gd-modal__content">
          {{ content }}
          <slot></slot>
        </div>
      </div>
    </div>
</template>

<script>
import IconClose from '@/assets/svg/icon-close.svg';

export default {
  name: 'modal',

  components: {
    IconClose,
  },

  props: {
    content: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  },

  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue